/**
 * Implementation of Email sent component
 *
 * @author - Harsh Tomar
 */

// Dependencies
import React from "react";
import { MdMarkEmailRead } from "react-icons/md";
import { useLocation } from "react-router-dom";

export default function EmailSent() {
  const { state } = useLocation() as { state: { email: string }};
  return (
    <>
      <div className="flex justify-center items-center">
        {/* <div className=" w-20 h-20 flex justify-center items-center rounded-full"> */}
        <MdMarkEmailRead size={48} className="text-primary" />
        {/* </div> */}
      </div>
      <h1 className="text-2xl mb-5 mt-3 text-center">
        Email sent successfully!
      </h1>
      <p className="text-center text-gray-700">
        An email has been sent to{" "}
        <em className="text-blue-400">{state?.email}</em> <br />
        Please check your inbox to continue signing in.
      </p>
    </>
  );
}
